/**
 * Schadensklassifizierung reducer.
 * @module reducers/schadensklassifizierung/schadensklassifizierung
 */

import {
  GET_SCHADENSKLASSIFIZIERUNG,
  SET_PROJECT,
  SET_BUCKET,
} from "../../constants/ActionTypes";
import { isEmpty } from "lodash";

const initialState = {
  error: null,
  data: {
    schadensart: [],
    schadensklasseStandsicherheit: [],
    schadensklasseBetrieb: [],
    schadensklasseDichtheit: [],
  },
  loaded: false,
  loading: false,
};

/**
 * Schadensklassifizierung reducer.
 * @function schadensklassifizierung
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function schadensklassifizierung(
  state = initialState,
  action = {}
) {
  switch (action.type) {
    case `${GET_SCHADENSKLASSIFIZIERUNG}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_SCHADENSKLASSIFIZIERUNG}_SUCCESS`:
      return {
        ...state,
        error: null,
        data: !isEmpty(action.result) ? action.result : initialState.data,
        loaded: true,
        loading: false,
      };
    case `${GET_SCHADENSKLASSIFIZIERUNG}_FAIL`:
      return {
        ...state,
        error: action.error,
        data: initialState.data,
        loaded: false,
        loading: false,
      };
    case SET_BUCKET:
      return {
        ...initialState,
      };
    case SET_PROJECT:
      return { ...initialState };
    default:
      return state;
  }
}
